export const isObjectId = (id: string) => /^[0-9a-fA-F]{24}$/.test(id)
